import { render, staticRenderFns } from "./component-details.vue?vue&type=template&id=9952f7ba&"
import script from "./component-details.vue?vue&type=script&lang=js&"
export * from "./component-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports